import { Component, inject, signal, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AbstractControl, FormBuilder, FormGroup, ReactiveFormsModule, ValidationErrors, Validators } from '@angular/forms';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { DatePickerModule } from 'primeng/datepicker';
import { ValidatorsService } from 'src/app/services/validators.service';
import { ProfileService } from '../../../services/profile.service';
import { AlertNotifyComponent } from 'src/app/core/components/alert-notify/alert-notify.component';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-modal-refresh-token',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    DialogModule,
    ButtonModule,
    DatePickerModule,
    AlertNotifyComponent
  ],
  templateUrl: './modal-refresh-token.component.html',
  styleUrls: ['./modal-refresh-token.component.scss']
})
export class ModalRefreshTokenComponent implements OnInit, OnDestroy {
  profileService = inject(ProfileService);
  validatorsService = inject(ValidatorsService);
  private fb = inject(FormBuilder);

  loading = signal(false);
  minEndDate = signal<Date | null>(null);
  private sub?: Subscription;

  tokenForm: FormGroup = this.fb.group({
    siatToken: ['', [Validators.required, Validators.minLength(10)]],
    tokenInitDate: [null, [Validators.required]],
    tokenEndDate: [null, [Validators.required]],
  }, { validators: this.dateRangeValidator });

  dateRangeValidator(control: AbstractControl): ValidationErrors | null {
    const initDate = control.get('tokenInitDate')?.value;
    const endDate = control.get('tokenEndDate')?.value;
    if (!initDate || !endDate) return null;

    const start = new Date(initDate).getTime();
    const end = new Date(endDate).getTime();
    return end > start ? null : { invalidDateRange: true };
  }

  ngOnInit(): void {
    this.sub = this.tokenForm.get('tokenInitDate')?.valueChanges.subscribe((initDate) => {
      if (initDate) {
        this.minEndDate.set(new Date(initDate));
      } else {
        this.minEndDate.set(null);
      }
    });
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }

  onHide(): void {
    this.tokenForm.reset();
    this.loading.set(false);
    this.minEndDate.set(null);
  }

  resfreshTokenSiat(): void {
    this.tokenForm.markAllAsTouched();
    if (this.tokenForm.invalid) return;

    this.loading.set(true);
    this.profileService.putRefreshToken(this.tokenForm.value).subscribe({
      next: () => {
        this.loading.set(false);
        this.profileService.save$.next(true);
        this.validatorsService.showToast('success', '¡Éxito!', 'Token Delegado SIAT y vigencia actualizados correctamente');
        this.profileService.showModalToken = false;
        this.onHide();
      },
      error: (err) => {
        this.loading.set(false);
        const errorMsg = err?.error?.message || err?.message || 'Error al actualizar el token SIAT. Verifique los datos ingresados.';
        this.validatorsService.showToast('danger', 'Error al Guardar Token', errorMsg);
      }
    });
  }
}
